import {useQuery} from "@tanstack/react-query";
import {fetchDELETE, fetchGET, fetchPOST, fetchPUT} from "./fetch";
import {useMyMutation} from "./mymutation";

const REACT_QUERY_ID_PAGES = "countrycodes";
const BASE_URL = "/api/countrycodes";

const CountryCodesQueryConfig = {
    staleTime: 0,
    cacheTime: 1000 * 60 * 5,
}


export function useCountryCodes() {
    const result = useQuery({
        queryKey: [REACT_QUERY_ID_PAGES],
        queryFn: async () => await fetchGET(BASE_URL),
        //onError: e => setError(e),
        ...CountryCodesQueryConfig
    });
    return {...result, countrycodes: result.data};
}


export function useCountryCode(id) {
    const result = useQuery({
        queryKey: [REACT_QUERY_ID_PAGES, id],
        queryFn: async () => id ? await fetchGET(`${BASE_URL}/${id}`) : {},
        //onError: e => setError(e),
        ...CountryCodesQueryConfig
    });
    return {...result, countryCode: result.data};
}

export function useCountryCodesMutations() {
    async function createFunction(countryCode) {
        if (!countryCode) return;
        return await fetchPOST(BASE_URL, countryCode, false);
    }

    async function editFunction(countryCode) {
        if (!countryCode) return;
        return await fetchPUT(`${BASE_URL}/${countryCode.id}`, countryCode);
    }

    async function editAddNewFiles(countryCode) {
        if (!countryCode) return;
        return await fetchPUT(`${BASE_URL}/${countryCode.id}/files`, countryCode.filesIds);
    }

    async function deleteFunction(countryCode) {
        return await fetchDELETE(`${BASE_URL}/${countryCode.id}`)
    }

    return {
        createCountryCode: useMyMutation(createFunction, REACT_QUERY_ID_PAGES, countryCode => `CountryCode ${countryCode.title} created`),
        editCountryCode: useMyMutation(editFunction, REACT_QUERY_ID_PAGES, countryCode => `CountryCode ${countryCode.title} modified`),
        editAddNewFiles: useMyMutation(editAddNewFiles, REACT_QUERY_ID_PAGES, countryCode => `CountryCode ${countryCode.title} modified`),
        deleteCountryCode: useMyMutation(deleteFunction, REACT_QUERY_ID_PAGES, countryCode => `CountryCode ${countryCode.title} deleted.`)
    };

}